import { Col, Row } from 'antd';
import React, { ReactNode, memo } from 'react';
import styled from 'styled-components';

import useWindowSize from 'app/hooks/useWindowSize';
import AccountManager, {
  ACCOUNT_MNG_MENU,
} from 'app/pages/NewAccount/layouts/AccountManager';
import { ReactComponent as ArrowDown } from '../../../assets/img/arrow_down.svg';
import { StyledStack } from 'app/components/Stack';
import ContainerFluid from 'app/components/Layout/ContainerFluid';

interface LayoutProps {
  title?: string | ReactNode;
  children: ReactNode;
  menuActive?: ACCOUNT_MNG_MENU;
  preElement?: ReactNode;
  sufElement?: ReactNode;
  disableContainerStyle?: boolean;
  useBackArrow?: boolean;
  onBack?: () => void;
}

export const Layout = memo((props: LayoutProps) => {
  const {
    title,
    children,
    menuActive,
    preElement,
    sufElement,
    disableContainerStyle,
    useBackArrow,
    onBack,
  } = props;
  const { device } = useWindowSize();

  return (
    <ContainerFluid>
      <Col span={24}>
        <Row
          style={{
            marginTop: 16,
            marginBottom: 24,
            width: '100%',
          }}
          justify="center"
          gutter={device === 'desktop' ? 24 : 0}
        >
          {device === 'desktop' && (
            <Col span={6}>
              <AccountManager menuActive={menuActive} />
            </Col>
          )}
          <Col span={device === 'desktop' ? 18 : 24}>
            {preElement}
            <div
              style={
                !disableContainerStyle
                  ? {
                      borderRadius: 20,
                      background: '#FFFFFF',
                      padding: device === 'desktop' ? '24px 24px' : '16px',
                      boxShadow: '0px 20px 20px 0px #0000000D',
                      display: 'flex',
                      flexDirection: 'column',
                    }
                  : {}
              }
            >
              <StyledStack alignItem={'center'} columnGap={'5px'}>
                {useBackArrow ? (
                  <ArrowDown
                    style={{
                      cursor: 'pointer',
                      marginBottom: 14,
                      height: 18,
                      width: 18,
                      transform: 'rotate(90deg)',
                    }}
                    onClick={() => onBack && onBack()}
                  />
                ) : null}
                {title ? (
                  typeof title === 'string' ? (
                    <StyledH4
                      style={{
                        marginBottom: 14,
                        display: 'inline-block',
                        cursor: !!onBack ? 'pointer' : 'default',
                      }}
                      device={device}
                      onClick={() => onBack && onBack()}
                    >
                      {title}
                    </StyledH4>
                  ) : (
                    title
                  )
                ) : null}
              </StyledStack>
              {children}
            </div>
            {sufElement}
          </Col>
        </Row>
      </Col>
    </ContainerFluid>
  );
});

export const StyledH4 = styled.h4<{ device?: 'mobile' | 'tablet' | 'desktop' }>`
  font-weight: 600;
  font-size: ${props => (props.device === 'desktop' ? '20px' : '18px')};
  text-transform: uppercase;
  color: #000 !important;
`;
